import { PageViewEventLogger } from '@repo/tracking-service';
import { ForgotPassword, SignBackButtonLayout } from '@repo/user-sign';
import { ReactElement } from 'react';

const ForgotPasswordPage = () => {
  return (
    <>
      <ForgotPassword />
      <PageViewEventLogger pageName={'forgot-password'} />
    </>
  );
};

ForgotPasswordPage.getLayout = (page: ReactElement) => <SignBackButtonLayout>{page}</SignBackButtonLayout>;

export default ForgotPasswordPage;
